export default {
    data() {
        return {
            show_tj: false,
            tjs: {
                data: [],
            },
            admins: [],
            table: 'comm',
            datas: {
                add: {
                    append: ['status_info', 'admin']
                }
            }
        };
    },
    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 5) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                if (this.r.status >= 2) {
                    return true;
                }
                return false;
            }
            return true;
        }
    },
    created() {
        this.datas.add = {
            ...this.datas.add,
            ...this.$route.query || {}
        };
        this._load();
        this._admins([4]);
    },
    methods: {
        _ok(id) {
            this.$confirm(`确定上报已完成资料给主管审核吗`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('comm/sb', {
                    id
                }).then(res => {
                    if (res.code) {
                        this._load();
                    }
                })
            }).catch(() => {
            });
        },
        _tc_cw() {
            this.$http.post('comm/tc_cw', {
                admin_zl: this.tjs.admin.id
            }).then(res => {
                if (res.code) {
                    this.show_tj = false;
                }
            })
        },
        _get_tjs(id) {
            this.$http.post('comm/tjs', {
                id
            }).then(res => {
                if (res.code) {
                    this.tjs = res.data;
                    this.show_tj = true;
                }
            })
        },
    },
};